import { calcCartItemTotalPrice, clone } from '..'

export const prepareItemsForCoupon = (items) => {
	let itemsCopy = clone(items)
	itemsCopy = itemsCopy.filter(item => item.type !== 'EXTRA_DISCOUNT')

	const categoryDiscounts = itemsCopy.filter(item => item.type === 'CATEGORY_DISCOUNT')

	const resultItems = itemsCopy
		.filter(item => item.type !== 'MARKETING_COUPON' && item.type !== 'CATEGORY_DISCOUNT')
		.map(item => {
			const categoryDiscount = categoryDiscounts.find(cd => cd.targetItemPositionId && cd.targetItemPositionId === item.itemPositionId)
			if (!categoryDiscount) return item
			const lineTotal = calcCartItemTotalPrice(item)
			if (!lineTotal) return item
			return { ...item, discountInfo: { value: (Math.abs(categoryDiscount.price) / lineTotal) * 100, type: 'PERCENTS', enabledWithOtherDiscounts: false } }
		})
	const marketingCoupon = itemsCopy.find(item => item.type === 'MARKETING_COUPON')

	return { resultItems, marketingCoupon }
}
